/**
 * Mémoire du point de recherche (chantier store-locator-revendeurs, point 4,
 * invariant R6) : conserve, pour l'onglet en cours seulement, le point de
 * recherche arrondi afin de pouvoir afficher une distance sur la fiche
 * magasin au point 7. Clé dédiée, jamais les clés du magasin de retrait
 * (`livraisonStoreMethod`, `selectedStore*`, `csmStorePreselected`) ni un
 * cookie : aucune écriture liée au parcours de commande.
 */

export const STORE_LOCATOR_REFERENCE_KEY = 'ndStoreLocatorRef';

/** Arrondi à 4 décimales (~11 m de précision), suffisant pour une distance affichée en mètres/km. */
export function roundCoordinate(value) {
  return Math.round(value * 10000) / 10000;
}

/**
 * Enregistre (ou efface, si `point` est `null`) le point de recherche courant.
 * Volontairement silencieux si `sessionStorage` est indisponible (navigation
 * privée, quota) : la distance affichée redevient simplement indisponible,
 * jamais une erreur bloquante.
 * @param  {{lng: number, lat: number}|null} point
 */
export function saveStoreLocatorReference(point) {
  try {
    if (!point) {
      window.sessionStorage.removeItem(STORE_LOCATOR_REFERENCE_KEY);
      return;
    }
    window.sessionStorage.setItem(
      STORE_LOCATOR_REFERENCE_KEY,
      JSON.stringify({ lng: roundCoordinate(point.lng), lat: roundCoordinate(point.lat) }),
    );
  } catch (error) {
    // sessionStorage indisponible : pas d'écriture, pas d'erreur remontée.
  }
}

/**
 * Relit le point de recherche mémorisé par l'onglet (usage prévu au point 7,
 * fiche magasin). Non utilisé sur la liste elle-même : la liste garde son
 * propre état en mémoire tant que l'onglet reste ouvert (scénarios 5, 6, 8).
 * @returns {{lng: number, lat: number}|null}
 */
export function loadStoreLocatorReference() {
  try {
    const raw = window.sessionStorage.getItem(STORE_LOCATOR_REFERENCE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
}
